// src/pages/AboutPage.js
import React from 'react';
import "./LegalPages.css";

function AboutPage() {
  return (
    <div className="legal-page">
      <h1>📌 SOBRE NOSOTROS - SANTO DOMINGO ESPECTÁCULOS</h1>
      <h2>📌 Información de Contacto</h2>
      <p><strong>Nombre:</strong> Santo Domingo Espectáculos</p>
      <p><strong>Teléfono y WhatsApp:</strong> +1 (849) 650-9878</p>
      <p><strong>Email:</strong> santodomingoespectaculos@gmail.com</p>
      <p><strong>Dirección:</strong> Av. Los Próceres No. 40, Plaza Rey-Mart, Local 105, Santo Domingo, Distrito Nacional, República Dominicana</p>
      <p><strong>Horario de Atención:</strong></p>
      <ul>
        <li>Lunes a Viernes: 9:00 AM - 6:00 PM</li>
        <li>Sábados: 9:00 AM - 2:00 PM</li>
      </ul>
      <p>Somos un portal dedicado a la venta de tickets, noticias de eventos y farándula en la República Dominicana.</p>
      <p>Nos especializamos en brindar una plataforma segura y confiable para que nuestros clientes puedan acceder a los mejores eventos en Santo Domingo y más allá.</p>
      
      <h2>Nuestra Misión</h2>
      <p>Facilitar el acceso a eventos de entretenimiento de manera rápida, sencilla y segura, proporcionando un servicio de calidad y atención al cliente excepcional.</p>
      
      <h2>Nuestra Visión</h2>
      <p>Convertirnos en la plataforma líder de venta de tickets y noticias de eventos en la región, ofreciendo siempre innovación y excelencia.</p>
      
      <h2>¿Por qué elegirnos?</h2>
      <ul>
        <li>🎟 Venta de tickets con confirmación inmediata.</li>
        <li>🔒 Seguridad en las transacciones y protección de datos.</li>
        <li>📢 Noticias y cobertura exclusiva de eventos.</li>
        <li>📞 Atención al cliente personalizada.</li>
      </ul>
      
      
    </div>
  );
}
export default AboutPage;
